export const isCompletedStatus = (status) => {
  return status === 'completed' || status === 'historical'
}

export const isExpiredStatus = (status) => {
  return status === 'expired' || status === 'stale'
}

export const isInProgressStatus = (status) => {
  return !isCompletedStatus(status) && !isExpiredStatus(status)
}
